import React from 'react';
import { FlightTextInput } from '@flybits/design-system';

const MAIN_CLASS = 'templates-library-modal__search';

type TemplatesLibrarySearchProps = {
  value: string;
  onChange: (value: string) => void;
};

/** Search field used by the templates library modal; reports the raw input value. */
export const TemplatesLibrarySearch: React.FC<TemplatesLibrarySearchProps> = ({ value, onChange }) => (
  <FlightTextInput
    customClass={MAIN_CLASS}
    width="100%"
    iconInput="search"
    placeholderText="Search by template name"
    ariaLabel="Search by template name"
    value={value}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
  />
);
